import { createHubBatchMode } from "./hubBatchSelection";

export const INVOICE_HUB_BATCH_ACTIONS = Object.freeze({
  DELETE_DRAFTS: "delete-drafts",
  // Future: ARCHIVE_SELECTED, RESTORE_SELECTED
});

/**
 * Batch-selection modes keyed by invoice hub status filter.
 * Only `draft` is enabled today; other keys reserve the extension points.
 */
export const INVOICE_HUB_BATCH_MODES = Object.freeze({
  draft: createHubBatchMode({
    enabled: true,
    actions: [
      {
        id: INVOICE_HUB_BATCH_ACTIONS.DELETE_DRAFTS,
        label: (count) => `Delete Selected (${count})`,
        destructive: true,
      },
    ],
  }),
  sent: createHubBatchMode({ enabled: false, actions: [] }),
  paid: createHubBatchMode({ enabled: false, actions: [] }),
  archived: createHubBatchMode({ enabled: false, actions: [] }),
});

/**
 * @param {string|null} statusFilter - Active hub status filter (`null` = All)
 * @returns {import("./hubBatchSelection").HubBatchModeDefinition|null}
 */
export function getInvoiceHubBatchMode(statusFilter) {
  if (!statusFilter) return null;
  return INVOICE_HUB_BATCH_MODES[statusFilter]?.enabled
    ? INVOICE_HUB_BATCH_MODES[statusFilter]
    : null;
}
